import React from 'react'

const Footer = () => {
    return (
        < >
            <footer className='footer'>&copy; Jamil Ahmed<a style={{color:"#000"}} target='_blank' href="https://github.com/jamilahmed2">Github</a>
            </footer>
        </>
    )
}

export default Footer